/* Lazy iframe component. Gallery adapter must call deactivate() when leaving its slide. */
(() => {
  if (customElements.get('bvk-book-preview')) return;
  class BookPreview extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.poster = this.querySelector('.bvk-preview-poster');
      this.panel = this.querySelector('dialog');
      this.host = this.querySelector('.bvk-preview-frame');
      this.start = this.querySelector('.bvk-preview-start');
      this.closeButton = this.querySelector('[data-bvk-close]');
      this.expanded = false;
      this.start.addEventListener('click', () => this.activate());
      this.closeButton.addEventListener('click', () => this.deactivate(true));
      this.panel.addEventListener('cancel', event => { event.preventDefault(); this.deactivate(true); });
      this.panel.addEventListener('click', event => {
        if (event.target !== this.panel) return;
        const bounds = this.panel.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
          this.deactivate(true);
        }
      });
      // Keep theme image zoom and carousel drags out of the active controls.
      for (const type of ['pointerdown', 'touchstart', 'mousedown', 'click']) {
        this.panel.addEventListener(type, event => event.stopPropagation());
      }
    }
    activate() {
      if (this.frame) return;
      let url;
      try { url = new URL(this.dataset.url); } catch { return; }
      if (url.protocol !== 'https:' && !(url.protocol === 'http:' && url.hostname === '127.0.0.1')) return;
      this.frame = document.createElement('iframe');
      this.frame.title = `Blader door ${this.dataset.title || 'het boekje'}`;
      this.frame.referrerPolicy = 'strict-origin-when-cross-origin';
      this.frame.src = url.href;
      this.host.append(this.frame);
      this.poster.hidden = true;
      this.expanded = true;
      this.panel.classList.add('bvk-expanded');
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.panel.showModal();
      this.closeButton.focus({preventScroll:true});
      this.dispatchEvent(new CustomEvent('bvk:active', {bubbles:true,detail:{active:true}}));
    }
    deactivate(restoreFocus = false) {
      if (!this.frame) return;
      this.panel.close();
      this.expanded = false;
      this.panel.classList.remove('bvk-expanded');
      document.documentElement.style.overflow = this.oldOverflow;
      this.frame.remove();
      this.frame = null;
      this.poster.hidden = false;
      if (restoreFocus) this.start.focus({preventScroll:true});
      this.dispatchEvent(new CustomEvent('bvk:active', {bubbles:true,detail:{active:false}}));
    }
    disconnectedCallback() { this.deactivate(); }
  }
  customElements.define('bvk-book-preview', BookPreview);
})();

// Delegation also covers collection filters/pagination that replace the product grid.
(() => {
  let modal, frame, trigger, oldOverflow;
  const close = () => {
    if (!modal?.open) return;
    modal.close();
    frame?.remove(); frame = null;
    document.documentElement.style.overflow = oldOverflow;
    trigger?.focus({preventScroll:true});
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-bvk-library-url]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    let url;
    try { url = new URL(link.dataset.bvkLibraryUrl); } catch { return; }
    if (url.protocol !== 'https:' && !(url.protocol === 'http:' && url.hostname === '127.0.0.1')) return;
    if (typeof HTMLDialogElement === 'undefined') return; // Ordinary product link remains the fallback.
    event.preventDefault();
    if (!modal) {
      modal = document.createElement('dialog');
      modal.className = 'bvk-library-dialog';
      modal.setAttribute('aria-labelledby','bvk-library-title');
      modal.innerHTML = '<header class="bvk-library-header"><h2 id="bvk-library-title"></h2><button type="button" aria-label="Sluiten">&times;</button></header><div class="bvk-library-frame"></div><footer class="bvk-library-footer"><a class="bvk-library-product">Bekijk dit boekje</a></footer>';
      const details = document.getElementById('bvk-library-details');
      if (details) modal.querySelector('.bvk-library-footer').replaceChildren(...details.childNodes);
      document.body.append(modal);
      modal.querySelector('button').addEventListener('click',close);
      modal.addEventListener('cancel',e=>{e.preventDefault();close();});
      modal.addEventListener('click',e=>{if(e.target===modal){const r=modal.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
    }
    trigger = link;
    url.searchParams.set('mode','library');
    modal.querySelector('h2').textContent = link.dataset.bvkTitle || 'Bekijk het boekje';
    modal.querySelector('.bvk-library-product').href = link.href;
    window.bvkFavorites?.attach(modal.querySelector('.bvk-library-header'),link);
    frame = document.createElement('iframe');
    frame.title = `Blader door ${link.dataset.bvkTitle || 'het boekje'}`;
    frame.src = url.href;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    modal.querySelector('.bvk-library-frame').replaceChildren(frame);
    oldOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    modal.showModal();
    modal.querySelector('button[aria-label="Sluiten"]').focus({preventScroll:true});
  });
  window.addEventListener('message',e=>{
    if (frame && e.source===frame.contentWindow && e.origin===new URL(frame.src).origin && e.data?.type==='bvk:close') close();
  });
})();
